
import { Component } from 'react';
import { createRoot } from 'react-dom/client';

//import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';
//import { Swiper, SwiperSlide } from 'swiper/react';

import BannerItem from "./Banner.interface";

import CombinedBannerItem from "./CombinedBanner/CombinedBanner";
import BannersWithLinksItem from "./BannersWithLinks/BannersWithLinks";
import ChangingContentBannerItem from "./ChangingContentBanner/ChangingContentBanner";
import VideoBannerItem from "./VideoBanner/VideoBanner";
import MiniBannerItem from "./MiniBanner/MiniBanner";
import Helper from "Interfaces/Helper";

// Import Swiper styles
import '/node_modules/Swiper/swiper-bundle.min.css';
import '/node_modules/swiper/modules/pagination.min.css';
import '/node_modules/swiper/modules/navigation.min.css';
import '/node_modules/swiper/modules/a11y.min.css';

import './Banner.css';

import Consts from "Interfaces/Consts";
import Direction from 'Interfaces/Directions';

// configure Swiper to use modules
//SwiperCore.use([Navigation, Pagination, A11y, Autoplay]);

const mediaType = window.matchMedia("(min-width: 1200px)");
const API_URL = "/api/Banner";

// import function to register Swiper custom elements
import { register, SwiperContainer } from 'swiper/element/bundle';

// register Swiper custom elements
register();

class Banner extends Component {

    state:
        {
            error: boolean;
            isLoaded: boolean;
            componentId: string;
            componentQuery: string;
            currentPageId: number;
            items: BannerItem[];
            dir: string;
            isActive: boolean;
            bannerType: string;
            noLoopOnSingleMovie: boolean;

        };
    props: any;


    constructor(props) {
        super(props);
        this.state = {
            error: false,
            isLoaded: false,
            componentId: this.props.id,
            componentQuery: this.props.query,
            bannerType: this.props.bannerType ? this.props.bannerType : "CombinedBanner",
            currentPageId: this.props.currentPageId,
            items: [],
            dir: Direction,
            isActive: false,
            noLoopOnSingleMovie: this.props.noLoopOnSingleMovie === "1"
        };

    }
    componentDidMount() {

        Helper.fetchData({ API_URL, queryId: this.state.componentQuery, pageId: this.state.currentPageId })
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        items: result
                    });
                },
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error: true
                    });
                }
            )
    }



    componentDidUpdate() {
        const navMessage = { prevSlideMessage: Consts.prevSlideMessage, nextSlideMessage: Consts.nextSlideMessage }
        const bannerSwiper = document.getElementById("bannerID-" + this.state.componentId) as SwiperContainer;


        if (bannerSwiper && this.state.items.length > 0 && bannerSwiper["speed"] == undefined) {

            // swiper parameters
            const swiperParams = {
                slidesPerView: 1,
                speed: 800,
                autoHeight: this.state.bannerType == "ChangingContentBanner" || (this.state.bannerType == "BannersWithLinks" && this.state.items.length > 1) ? true : false,
                loop: this.state.items.length > 1 ? true : false,
                spaceBetween: 0,
                //centeredSlides: true,
                autoplay: this.state.items.length > 1 ? { "delay": 4000 } : false,
                navigation: mediaType.matches ? true : false,
                dir: Direction,
                a11y: navMessage,
                pagination: {
                    clickable: true,
                    type: "bullets",
                    renderBullet: function (index, className) {

                        return '<span class="mst-pagination-bullet ' + className + '"></span>';


                    },

                },


                on: {
                    init: function (swiper) {
                        //console.log(swiper);                      
                    },
                    afterInit: function (swiper) {

                        const swiperControl = document.querySelector('#' + swiper.el.offsetParent.id).parentElement;
                        const swiperContainer = document.querySelector('#' + swiper.el.offsetParent.id);
                        const controlBtn = swiperControl.querySelector('.mst-pause-btn');

                        const swiperPrevBtn = document.querySelector("#swiper-navigation-prev-" + swiper.el.offsetParent.id.split('-')[1]);
                        const swiperPagination = document.querySelector("#swiper-pagination-bullets-" + swiper.el.offsetParent.id.split('-')[1]);
                        const swiperNextBtn = document.querySelector("#swiper-navigation-next-" + swiper.el.offsetParent.id.split('-')[1]);


                        const swiperBtnNext = swiperContainer.shadowRoot.querySelector("div[part='button-next']");
                        const swiperBtnPrev = swiperContainer.shadowRoot.querySelector("div[part='button-prev']");

                        if (swiperBtnNext != null) { swiperBtnNext.setAttribute("id", "banner-next-btn-" + swiper.el.offsetParent.id.split('-')[1]) }
                        if (swiperBtnPrev != null) { swiperBtnPrev.setAttribute("id", "banner-prev-btn-" + swiper.el.offsetParent.id.split('-')[1]) }
                      
                        const swiperPaginationBullets = swiperContainer.shadowRoot.querySelector("div[part='pagination']");

                        if (swiperBtnPrev != null) {
                            swiperPrevBtn.appendChild(swiperBtnPrev);
                        }

                        swiperPagination.appendChild(swiperPaginationBullets);

                        if (swiperBtnNext != null) {
                            swiperNextBtn.appendChild(swiperBtnNext);
                        }
              
                        var slidesNum = "mst-slidesNum-" + swiper.slides.length;
                        swiperControl.classList.add(slidesNum);

                        if (swiper.slides.length == 1) {
                            const bannerText = swiper.slides[swiper.activeIndex].querySelector(".limited-content");
                            if (bannerText != null) { Helper.disableTabIndexOfHiddenContent(bannerText, true) }
                        }


                        setTimeout(function () {
                            if (controlBtn) {

                                controlBtn.addEventListener('click', function () {

                                    if (this.getAttribute('aria-pressed') === 'false' || this.getAttribute('aria-pressed') == null) {
                                        swiper.autoplay.stop();
                                        this.querySelector('.sr-only').textContent = Consts.play;
                                        this.querySelector('.fas').classList.remove('fa-pause');
                                        this.querySelector('.fas').classList.add('fa-play');                                       
                                        this.querySelector('.carousel-control-pause').setAttribute('aria-label', Consts.play);
                                        this.setAttribute('aria-pressed', 'true');
                                    } else {
                                        swiper.autoplay.start();
                                        this.querySelector('.sr-only').textContent = Consts.stop;
                                        this.querySelector('.fas').classList.remove('fa-play');
                                        this.querySelector('.fas').classList.add('fa-pause');
                                        this.querySelector('.carousel-control-pause').setAttribute('aria-label', Consts.stop);
                                        this.setAttribute('aria-pressed', 'false');
                                    }
                                });
                            }
                        }, 1000);
                    },
                    slideChange: function (swiper) {

                        const currentItem = swiper.slides[swiper.activeIndex];
                        const bannerColorType = currentItem.querySelector(".mst-Banner-Content");
                        const bannerPagination = document.querySelector("#swiper-pagination-" + swiper.el.offsetParent.id.split('-')[1]);
                        const bannerText = currentItem.querySelector(".limited-content");
       
                        if (bannerColorType.classList.contains("lightShadow")) {
                            bannerPagination.classList.add("lightShadow");
                        }
                        else {
                            bannerPagination.classList.remove("lightShadow");
                        }
                        if (bannerText != null) { Helper.disableTabIndexOfHiddenContent(bannerText, true) }
                       
                    },
                },
            };
            // now we need to assign all parameters to Swiper element
            Object.assign(bannerSwiper, swiperParams);
            // and now initialize it
            bannerSwiper.initialize();
        }


    }

    getSwiperElement = () => document.querySelector(".mst-banner-inner-" + this.state.componentId);

    focusOnActiveSlide = (e) => {
        if (e.shiftKey && e.keyCode == 9) {
            e.preventDefault();
            this.getSwiperElement().querySelector('.swiper-slide-active').setAttribute("tabindex", "0");
            (this.getSwiperElement().querySelector('.swiper-slide-active') as HTMLElement)?.querySelector('a').focus();

        }
    }

    pauseBanner = () => {

        const swiperElement = this.getSwiperElement();       
        const activeElement = swiperElement.querySelector(".swiper-slide-active");
        const videoElements = swiperElement.querySelectorAll("video");

       
        this.setState({ isActive: !this.state.isActive });


        if (this.state.isActive == false) {
         
            videoElements.forEach(vid => vid.pause());
        }
        else {
      
            videoElements.forEach(vid => vid.play());
        }

    }

    render() {

        const { error, isLoaded, items } = this.state;
       

        if (isLoaded && !error) {

            if (this.state.items.length == 0) {
                return (<div className="txt-invisible" > No return Items!!! </div>);
            }

          

            if (this.state.items.length > 0) {
             

                let arrBannerImg = [];
                this.state.items.slice(0, 5).map((banneritem, index) =>
                    arrBannerImg.push(<swiper-slide class="swiper-slide" key={index}>
                        {
                            this.renderItem(banneritem)
                        }
                    </swiper-slide>))

                return (

                    <>
                        {
                            (this.state.bannerType == "VideoBanner") ?

                                this.state.items.filter(item => !item.imageOrMovie.isImage || !item.mobileImageOrMovie.isImage).slice(0, 1).map(bannerItem =>
                                    <VideoBannerItem key={bannerItem.index} bannerItem={bannerItem} isVideoLoop={!this.state.noLoopOnSingleMovie} />
                                )
                                :

                                <div className={`container-fluid px-0 ${this.state.items.length == 1 ? 'mst-single-banner' : ''} ${this.state.items[0].oneSize ? "one-size" : ""}`}>
                                    <div className={this.bannerTypeClass()}>
                                        <div className={`swiper mst-banner-inner-${this.state.componentId}`}>
                                            <swiper-container init={false}
                                                class={`swiper-wrapper mst-banner-inner1-${this.state.componentId}`}
                                                id={`bannerID-${this.state.componentId}`}>

                                                {arrBannerImg}

                                            </swiper-container>
                                            <div className="mst-swiper-nav-line">

                                                <div id={"swiper-pagination-" + this.state.componentId} className="mst-swiper-pagination mx-auto" >

                                                    {(this.state.items.length > 1 || !this.state.items[0].imageOrMovie.isImage) &&

                                                        <div className="mst-pause">
                                                            <span className="mst-pause-btn my-auto">

                                                                <button id={"pause-carouselContentControls-" + this.state.componentId} className="btn  btn-pause carousel-control-pause" role="button" aria-label={Consts.stop} onKeyDown={this.focusOnActiveSlide} onClick={() => this.pauseBanner()}>
                                                                    <span className={`fas ${this.state.isActive ? 'fa-play ' : 'fa-pause '} `} aria-hidden="true"></span>
                                                                    <span className="sr-only">{Consts.stop}</span>
                                                                </button>


                                                            </span>
                                                        </div>
                                                    }
                                                    <div id={"swiper-navigation-prev-" + this.state.componentId} className="mst-swiper-navigation-prev my-auto"></div>
                                                    <div id={"swiper-pagination-bullets-" + this.state.componentId} className="mst-swiper-pagination-bullets my-auto"></div>
                                                    <div id={"swiper-navigation-next-" + this.state.componentId} className="mst-swiper-navigation-next my-auto"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                        }

                    </>




                );
            }
        }
        return (null);
    }

    renderItem = (bannerItem) => {

        const cancelVideoLoop = this.state.noLoopOnSingleMovie && this.state.items.length === 1

        const onVideoEnded = cancelVideoLoop ? this.pauseBanner : null

        switch (this.state.bannerType) {
            case "CombinedBanner":
                return <CombinedBannerItem bannerItem={bannerItem} dir={this.state.dir} cancelVideoLoop={cancelVideoLoop} onVideoEnded={onVideoEnded} />
            case "ChangingContentBanner":
                return <ChangingContentBannerItem bannerItem={bannerItem} dir={this.state.dir} cancelVideoLoop={cancelVideoLoop} onVideoEnded={onVideoEnded} />
            case "BannersWithLinks":
                return <BannersWithLinksItem bannerItem={bannerItem} cancelVideoLoop={cancelVideoLoop} onVideoEnded={onVideoEnded} />
            case "MiniBanner":
                return <MiniBannerItem bannerItem={bannerItem} dir={this.state.dir} cancelVideoLoop={cancelVideoLoop} onVideoEnded={onVideoEnded} />
            default:
                return <CombinedBannerItem bannerItem={bannerItem} cancelVideoLoop={cancelVideoLoop} onVideoEnded={onVideoEnded} />

        }

    }

   

    bannerTypeClass = () => {
        switch (this.state.bannerType) {
            case "CombinedBanner":
                return "combinedBanner"
            case "ChangingContentBanner":
                return "changingContentBanner"
            case "BannersWithLinks":
                return "bannersWithLinks"
            case "MiniBanner":
                return "combinedBanner miniBanner"
            default:
                return "combinedBanner"

        }
    }


}


var elements = document.querySelectorAll('[id^="Banner-"]');

for (var i = 0; i < elements.length; i++) {

    var rootElement = document.getElementById(elements[i].id);
    var root = createRoot(rootElement);
    var accordionId = rootElement.getAttribute('id').split('-')[1];

    root.render(
        <Banner
            modules={[]}
            query={rootElement.getAttribute('component-query')}
            id={accordionId}
            currentPageId={rootElement.getAttribute('component-currentPageId')}
            bannerType={rootElement.getAttribute('component-type')}
            noLoopOnSingleMovie={rootElement.getAttribute('component-noLoopOnSingleMovie')}
        />);

}
